export default "__VITE_ASSET__lR5y0XRJ__"